import { isNil } from 'lodash'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { pick } from '@eastcoal/common/utils/object'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'
import { BizType } from '@eastcoal/shared/enums/BizType'

import { PRICE_COMPARE_APPLY_PAGE_PATH } from '../../../../../../pages/TradeSession/Apply/constants/path'

import { HomePriceCompareApplyButtonProps } from './interface'

export const HomePriceCompareApplyButton = ({
  record: { bizId, bizType, applyStatus, memberId: auctionMemberId }
}: HomePriceCompareApplyButtonProps) => {
  const {
    member: { id: currentMemberId }
  } = useAuthStore(state => pick(state, ['member']))

  const forbiddenApplyStatus = isNil(applyStatus)
    ? false
    : [
        ApplyStatus.WAIT_ENTRUST_AUDIT,
        ApplyStatus.WAIT_PLATFORM_AUDIT,
        ApplyStatus.PLATFORM_AUDIT_SUCCESS,
        ApplyStatus.APPLY_SUCCESS
      ].includes(applyStatus as ApplyStatus)

  if (
    auctionMemberId === currentMemberId ||
    bizType !== BizType.PRICE_COMPARE ||
    forbiddenApplyStatus
  ) {
    return null
  }

  const to = () => {
    return stringifyUrl({
      url: PRICE_COMPARE_APPLY_PAGE_PATH,
      query: { id: bizId }
    })
  }

  return (
    <NavigateButton newtab to={to} type='primary'>
      前往报名
    </NavigateButton>
  )
}
